import { ApolloLink } from "@apollo/client";
const crehanaCurrentUrl = "u" < typeof window ? '' : `${window.location.pathname}${window.location.search}`;
const crehanaCurrentUrlLink = new ApolloLink((operation, forward)=>{
    operation.setContext(({ headers = {} })=>({
            headers: {
                ...headers,
                'crehana-current-url': crehanaCurrentUrl
            }
        }));
    return forward(operation);
});
const links_crehanaCurrentUrlLink = crehanaCurrentUrlLink;
export default links_crehanaCurrentUrlLink;
